import { createAction, props } from '@ngrx/store';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';

export const setUserInfo = createAction(
    '[userInfo] Set',
    props<{userInfo: IUserInfoCognito}>());
